/**
 * Checks whether the given user has global admin authority.
 * Returns true if the user's authorities contain 'GLOBAL_ADMIN' or 'ROLE_GLOBAL_ADMIN'.
 *
 * Accepts any object with an optional authorities array to avoid a circular dependency
 * between @ee/common/utils and @ee/common/models.
 */
export function isUserGlobalAdmin(user: { authorities?: any[] } | null | undefined): boolean {
  return user?.authorities?.some(
    (auth) => auth === 'GLOBAL_ADMIN' || auth === 'ROLE_GLOBAL_ADMIN'
  ) || false;
}
